import Cookies from 'js-cookie';
import React from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { Navigate } from 'react-router-dom';

const LayoutDashboard = (props) => {
  if (Cookies.get('token') !== undefined) {
    return (
      <div>
        <Navbar />
        <div className="container-fluid">
          <div className="row">
            <Sidebar />
            {props.children}
          </div>
        </div>
      </div>
    );
  } else if (Cookies.get('token') !== undefined) {
    window.alert('anda belum login');
    return <Navigate to={'/login'} />;
  }
};

export default LayoutDashboard;
